import React from 'react';
import EmployerCard from '../EmployerCard/EmployerCard';
import './Companies.scss';

export default class Companies extends React.Component {
    static defaultProps = {
        sectionType: 'followed-company',
        sectionTitle: 'companies you follow',
    };
    render() {
        const {
            items,
            sectionTitle,
            sectionMessage,
            callToAction,
        } = this.props;
        return (
            <div className="components-Employer-Companies">
                <div className="section-title">{sectionTitle}</div>
                {sectionMessage && (
                    <div className="section-message">{sectionMessage}</div>
                )}
                {callToAction && (
                    <div className="call-to-action">{callToAction}</div>
                )}
                {items.map((item, idx) => {
                    return (
                        <EmployerCard
                            key={item.companyId}
                            rating={item.rating}
                            size="xSmall"
                            companyName={item.companyName}
                            companyUrl={item.companyUrl}
                            logo={item.logo}
                            shouldLinkToRatings={true}
                        />
                    );
                })}
            </div>
        );
    }
}
